export default "__VITE_ASSET__58b40d8b__"